
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Tilføj den til din hjemmeskærm for en bedre oplevelse og nem adgang.`,
's224cbcec014ef6b5': `Tryk på Del-knappen i navigationslinjen`,
's37a9e8aec5713460': `Mere`,
's386eca8362ff6155': `Tryk på Mere, hvis der ikke er noget Del-ikon`,
's4e1e10a6ca408245': `Tryk på "Tilføj til hjemmeskærm"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Åbn din browsermenu`,
's681e399d63311fba': `Vis galleri`,
's7f0591f08e318eda': `Tryk på Mere i Del-menuen`,
's8114bd55cae5a22b': `Vælg Tilføj til Dock`,
's922329d6f6213590': `Tilføj til Dock`,
's9af56bf005b49c74': `Rul ned til "Tilføj til hjemmeskærm"`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sba52286c21552a4e': `Installer den på din enhed for en bedre oplevelse og nem adgang.`,
'sc16e00a7a8b2fde2': `Tilbage`,
'scdaf4bbff76674c8': `Tilføj til hjemmeskærm`,
'se0e473adfda8066c': `Åbn i din primære browser`,
'se740f75b95a51807': `Tilføj den til din Dock for en bedre oplevelse og nem adgang.`,
'sfea652f6580ff086': `Denne side har app-funktionalitet.`,
    };
  